import * as React from "react";
const SvgEmptyStateTimeline = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 105.672,
	height: 84.727,
	viewBox: "0 0 105.672 84.727",
	...props
}, /* @__PURE__ */ React.createElement("g", {
	id: "Group_18",
	"data-name": "Group 18",
	transform: "translate(0)"
}, /* @__PURE__ */ React.createElement("path", {
	id: "Path_670",
	"data-name": "Path 670",
	d: "M904.457,787.9l-.334,0q-.159-.1-.32-.2c-.066-.042-.133-.082-.2-.123q-1.664-1.016-3.348-1.949t-3.383-1.782a.14.14,0,0,1-.081-.16.039.039,0,0,1,.005-.012c.016-.03.051-.042.1-.017.139.07.279.139.418.211q1.7.862,3.394,1.811t3.358,1.98l.07.043Z",
	transform: "translate(-810.033 -703.263)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_671",
	"data-name": "Path 671",
	d: "M931.659,724.155h-.207l-.139-.2-3.286-4.609-5.379-7.546a.134.134,0,0,1-.023-.046c-.015-.056.026-.088.078-.083a.157.157,0,0,1,.109.07l3.016,4.23,5.352,7.508.34.477C931.567,724.024,931.613,724.089,931.659,724.155Z",
	transform: "translate(-832.923 -639.491)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_672",
	"data-name": "Path 672",
	d: "M1011.374,705.613c-.011.348-.034.691-.064,1.031l-.018.195h-.217c.007-.065.013-.13.019-.195.046-.491.078-.987.083-1.5a20.879,20.879,0,0,0-.411-4.21,26.2,26.2,0,0,0-1.273-4.373,30.031,30.031,0,0,0-2.083-4.327.116.116,0,0,1-.019-.077c.009-.062.091-.08.153-.021a.183.183,0,0,1,.031.039q.15.258.295.518a30.016,30.016,0,0,1,1.994,4.342,26.093,26.093,0,0,1,1.187,4.38A20.605,20.605,0,0,1,1011.374,705.613Z",
	transform: "translate(-908.032 -622.149)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_674",
	"data-name": "Path 674",
	d: "M680.813,803.514h-.175l-.167-.1-.1-.064q-.869-.531-1.75-1.019t-1.768-.931a.073.073,0,0,1-.042-.084l0-.006c.008-.016.027-.022.054-.009l.218.11q.891.451,1.774.946t1.755,1.035l.037.023Z",
	transform: "translate(-615.118 -718.895)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_675",
	"data-name": "Path 675",
	d: "M695.026,770.2h-.108l-.073-.1-1.717-2.409-2.811-3.944a.072.072,0,0,1-.012-.024c-.008-.029.013-.046.041-.043a.082.082,0,0,1,.057.036l1.576,2.211,2.8,3.923.178.249Z",
	transform: "translate(-627.079 -685.569)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_676",
	"data-name": "Path 676",
	d: "M736.685,760.512c-.006.182-.018.361-.033.539l-.009.1h-.113c0-.034.007-.068.01-.1.024-.256.041-.516.043-.782a10.911,10.911,0,0,0-.215-2.2,13.692,13.692,0,0,0-.665-2.285,15.69,15.69,0,0,0-1.089-2.261.06.06,0,0,1-.01-.04c0-.032.048-.042.08-.011a.1.1,0,0,1,.016.021q.078.135.154.271a15.686,15.686,0,0,1,1.042,2.269,13.641,13.641,0,0,1,.62,2.289A10.772,10.772,0,0,1,736.685,760.512Z",
	transform: "translate(-666.33 -676.508)",
	fill: "#fff"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_677",
	"data-name": "Path 677",
	d: "M154.405,294.857H137.28a1.788,1.788,0,0,1-1.786-1.786V272.5a1.788,1.788,0,0,1,1.786-1.786h17.125a1.788,1.788,0,0,1,1.786,1.786v20.571a1.788,1.788,0,0,1-1.786,1.786ZM137.28,270.942a1.56,1.56,0,0,0-1.558,1.558v20.571a1.56,1.56,0,0,0,1.558,1.558h17.125a1.56,1.56,0,0,0,1.558-1.558V272.5a1.56,1.56,0,0,0-1.558-1.558Z",
	transform: "translate(-135.493 -248.782)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_678",
	"data-name": "Path 678",
	d: "M188.108,261.03H180.1a1.426,1.426,0,0,1-1.424-1.424V259.3a1.426,1.426,0,0,1,1.424-1.424h8.006a1.426,1.426,0,0,1,1.424,1.424v.305A1.426,1.426,0,0,1,188.108,261.03Z",
	transform: "translate(-173.756 -237.406)",
	fill: "#ccc"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_679",
	"data-name": "Path 679",
	d: "M166.794,371.152H151.088a.811.811,0,0,1,0-1.621h15.707a.811.811,0,0,1,0,1.621Z",
	transform: "translate(-148.592 -336.337)",
	fill: "#747678"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_680",
	"data-name": "Path 680",
	d: "M166.794,401.386H151.088a.811.811,0,0,1,0-1.621h15.707a.811.811,0,0,1,0,1.621Z",
	transform: "translate(-148.592 -363.126)",
	fill: "#747678"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_681",
	"data-name": "Path 681",
	d: "M195.287,340.918h-7.3a.811.811,0,1,1,0-1.621h7.3a.811.811,0,0,1,0,1.621Z",
	transform: "translate(-181.29 -309.548)",
	fill: "#747678"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_682",
	"data-name": "Path 682",
	d: "M473.64,115.231H456.515a1.788,1.788,0,0,1-1.786-1.786V92.875a1.788,1.788,0,0,1,1.786-1.786H473.64a1.788,1.788,0,0,1,1.786,1.786v20.571A1.788,1.788,0,0,1,473.64,115.231ZM456.515,91.316a1.56,1.56,0,0,0-1.558,1.558v20.571A1.56,1.56,0,0,0,456.515,115H473.64a1.56,1.56,0,0,0,1.558-1.558V92.875a1.56,1.56,0,0,0-1.558-1.558Z",
	transform: "translate(-418.35 -89.626)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_683",
	"data-name": "Path 683",
	d: "M507.343,81.4h-8.006a1.426,1.426,0,0,1-1.424-1.424v-.305a1.426,1.426,0,0,1,1.424-1.424h8.006a1.426,1.426,0,0,1,1.424,1.424v.305A1.426,1.426,0,0,1,507.343,81.4Z",
	transform: "translate(-456.612 -78.25)",
	fill: "#ccc"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_684",
	"data-name": "Path 684",
	d: "M486.03,191.526H470.323a.811.811,0,0,1,0-1.621H486.03a.811.811,0,0,1,0,1.621Z",
	transform: "translate(-431.448 -177.18)",
	fill: "#747678"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_685",
	"data-name": "Path 685",
	d: "M486.03,221.76H470.323a.811.811,0,0,1,0-1.621H486.03a.811.811,0,0,1,0,1.621Z",
	transform: "translate(-431.448 -203.969)",
	fill: "#747678"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_686",
	"data-name": "Path 686",
	d: "M514.522,161.292h-7.3a.811.811,0,1,1,0-1.621h7.3a.811.811,0,0,1,0,1.621Z",
	transform: "translate(-464.146 -150.392)",
	fill: "#747678"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_687",
	"data-name": "Path 687",
	d: "M713.3,440.576l-15.037,8.2a1.788,1.788,0,0,1-2.423-.714l-9.844-18.063a1.788,1.788,0,0,1,.714-2.423l15.037-8.2a1.788,1.788,0,0,1,2.423.714l9.844,18.063A1.788,1.788,0,0,1,713.3,440.576Zm-26.481-12.8a1.56,1.56,0,0,0-.622,2.114l9.844,18.063a1.56,1.56,0,0,0,2.114.622l15.037-8.2a1.56,1.56,0,0,0,.623-2.114L703.966,420.2a1.56,1.56,0,0,0-2.114-.622Z",
	transform: "translate(-623.067 -380.311)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_688",
	"data-name": "Path 688",
	d: "M725.7,430.361l-7.03,3.831a1.426,1.426,0,0,1-1.932-.569l-.146-.268a1.426,1.426,0,0,1,.569-1.932l7.03-3.831a1.426,1.426,0,0,1,1.932.569l.146.268A1.426,1.426,0,0,1,725.7,430.361Z",
	transform: "translate(-650.217 -387.628)",
	fill: "#ccc"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_689",
	"data-name": "Path 689",
	d: "M757.976,511.466l-13.792,7.516a.811.811,0,1,1-.776-1.424l13.792-7.516a.811.811,0,0,1,.776,1.424Z",
	transform: "translate(-673.758 -460.749)",
	fill: "#ccc"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_690",
	"data-name": "Path 690",
	d: "M772.444,538.014l-13.792,7.516a.811.811,0,0,1-.776-1.424l13.792-7.516a.811.811,0,0,1,.776,1.424Z",
	transform: "translate(-686.577 -484.272)",
	fill: "#ccc"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_691",
	"data-name": "Path 691",
	d: "M768.526,502.578l-6.406,3.491a.811.811,0,1,1-.776-1.424l6.406-3.491a.811.811,0,1,1,.776,1.424Z",
	transform: "translate(-689.65 -452.874)",
	fill: "#ccc"
}), /* @__PURE__ */ React.createElement("rect", {
	id: "Rectangle_1284",
	"data-name": "Rectangle 1284",
	width: 9.262,
	height: .228,
	transform: "matrix(0.865, -0.502, 0.502, 0.865, 23.808, 23.279)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_692",
	"data-name": "Path 692",
	d: "M1.141,1.971,2.273,0,0,.005Z",
	transform: "translate(24.488 24.359) rotate(180)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_693",
	"data-name": "Path 693",
	d: "M382.477,385.461a.113.113,0,0,1-.052-.013L351.64,369.634a.114.114,0,0,1,.1-.2l30.785,15.814a.114.114,0,0,1-.052.215Z",
	transform: "translate(-326.953 -336.238)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_694",
	"data-name": "Path 694",
	d: "M480.081,422.76l2.27-.112-1.231-1.91Z",
	transform: "translate(-425.373 -372.792)",
	fill: "#3f3d56"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_695",
	"data-name": "Path 695",
	d: "M890.946,541.149a1.224,1.224,0,0,1-.438-1.825l-.915-8.95h1.978l.728,8.739a1.231,1.231,0,0,1-1.353,2.036Z",
	transform: "translate(-803.658 -478.851)",
	fill: "#ffb6b6"
}), /* @__PURE__ */ React.createElement("circle", {
	id: "Ellipse_94",
	"data-name": "Ellipse 94",
	cx: 2.799,
	cy: 2.799,
	r: 2.799,
	transform: "translate(82.672 40.985)",
	fill: "#ffb6b6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_696",
	"data-name": "Path 696",
	d: "M844.156,503.431l-4.177-.912a.514.514,0,0,1-.4-.475,16.777,16.777,0,0,1,.635-5.595,3.39,3.39,0,0,1,4.356-2.16h0a3.392,3.392,0,0,1,1.926,4.682,28.3,28.3,0,0,0-1.734,4.094.512.512,0,0,1-.6.364Z",
	transform: "translate(-759.322 -446.708)",
	fill: "#00ad83"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_697",
	"data-name": "Path 697",
	d: "M693.883,689.192h-1.4l-.665-5.389h2.062Z",
	transform: "translate(-612.983 -605.879)",
	fill: "#ffb6b6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_698",
	"data-name": "Path 698",
	d: "M675.705,727.588H678.4v1.7h-4.391A1.7,1.7,0,0,1,675.705,727.588Z",
	transform: "translate(-597.201 -644.675)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_699",
	"data-name": "Path 699",
	d: "M798.269,678.486l-1.224.673-3.179-4.4,1.807-.993Z",
	transform: "translate(-703.4 -596.984)",
	fill: "#ffb6b6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_700",
	"data-name": "Path 700",
	d: "M1.7,0H4.391V1.7H0A1.7,1.7,0,0,1,1.7,0Z",
	transform: "translate(91.092 83.123) rotate(-28.801)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_701",
	"data-name": "Path 701",
	d: "M821.386,585.906l-2.151-.166a.512.512,0,0,1-.471-.462c-.307-3.2-1.651-19.4,1.986-24.387l.01-.014.016-.006c.033-.012,3.276-1.169,5.137.951a.513.513,0,0,1,.1.5l-.071.213a.4.4,0,0,0,.057.362c.516.7,2.255,3.387,2.938,8.675a.4.4,0,0,0,.026.1l5.044,12.391a.513.513,0,0,1-.292.672l-1.587.6a.516.516,0,0,1-.632-.232L824.213,571.9a.285.285,0,0,0-.532.1l-1.747,13.464a.513.513,0,0,1-.508.447Z",
	transform: "translate(-740.461 -505.585)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_702",
	"data-name": "Path 702",
	d: "M771.688,483.821a1.2,1.2,0,0,1,.027.187l4.9,2.824,1.19-.685,1.268,1.661-1.989,1.417a.912.912,0,0,1-1.094-.027l-5.048-3.982a1.2,1.2,0,1,1,.749-1.395Z",
	transform: "translate(-697.098 -436.785)",
	fill: "#ffb6b6"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_703",
	"data-name": "Path 703",
	d: "M833.75,500.169a.512.512,0,0,1,.252-.345l2.246-1.256a1.424,1.424,0,1,1,1.747,2.25l-1.791,1.86a.513.513,0,0,1-.775-.042l-1.582-2.051A.512.512,0,0,1,833.75,500.169Z",
	transform: "translate(-754.169 -450.405)",
	fill: "#00ad83"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_704",
	"data-name": "Path 704",
	d: "M882.569,512.876a.512.512,0,0,1-.19-.382l-.081-2.573a1.424,1.424,0,1,1,2.8-.514l.826,2.446a.513.513,0,0,1-.395.669l-2.549.46A.512.512,0,0,1,882.569,512.876Z",
	transform: "translate(-797.174 -459.239)",
	fill: "#00ad83"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_705",
	"data-name": "Path 705",
	d: "M858.933,429.967c-.719.492-1.664,1-2.4.474a1.337,1.337,0,0,1-.439-1.541,3.288,3.288,0,0,1,2.243-1.788,6.44,6.44,0,0,1,3.75-.476,2.661,2.661,0,0,1,2.113,2.777c-.18,1.014-1.136,1.857-1,2.877s1.292,1.568,2.311,1.751a5.192,5.192,0,0,1,2.893.975,2.718,2.718,0,0,1-.178,3.591,6.553,6.553,0,0,1-3.493,1.738,8.5,8.5,0,0,1-5.166-.054c-1.619-.668-2.878-2.468-2.409-4.155a5.8,5.8,0,0,1,1.115-1.9,5.3,5.3,0,0,0,1.079-1.919,2,2,0,0,0-.36-1.745.506.506,0,0,1-.068-.591Z",
	transform: "translate(-773.905 -386.827)",
	fill: "#2f2e41"
}), /* @__PURE__ */ React.createElement("path", {
	id: "Path_706",
	"data-name": "Path 706",
	d: "M723.331,819.978H679.914a.114.114,0,0,1,0-.228h43.417a.114.114,0,0,1,0,.228Z",
	transform: "translate(-617.773 -735.251)",
	fill: "#3f3d56"
})));
export default SvgEmptyStateTimeline;
